import { render } from "./EditDeleteKebab.vue?vue&type=template&id=b00d3ed6"
import script from "./EditDeleteKebab.vue?vue&type=script&lang=js"
export * from "./EditDeleteKebab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__